/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_sku = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSellerTabsVariant_sku">;
    readonly " $refType": "PdpRespDealerDetails_sku";
};
export type PdpRespDealerDetails_sku$data = PdpRespDealerDetails_sku;
export type PdpRespDealerDetails_sku$key = {
    readonly " $data"?: PdpRespDealerDetails_sku$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_sku">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};
(node as any).hash = 'ab4c00aeb0b3710b542de9d539aac2ce';
export default node;
